import { render } from "./QwilrDefinitionTemplate.vue?vue&type=template&id=014d28e7"
import script from "./QwilrDefinitionTemplate.vue?vue&type=script&lang=js"
export * from "./QwilrDefinitionTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__